import { Outlet, useOutletContext } from 'react-router-dom';

import type { AppRouteContext } from '../app';

export default function CustomerLayout() {
  const context = useOutletContext<AppRouteContext>();

  return <Outlet context={context} />;
}
